import React from 'react';
import { motion } from 'framer-motion';
import { ShieldIcon, DollarSignIcon, BriefcaseIcon } from 'lucide-react';
const pillars = [{
  icon: ShieldIcon,
  title: 'Protección Legal Inmediata',
  description: 'Conoce tus derechos desde el minuto uno'
}, {
  icon: DollarSignIcon,
  title: 'Auditoría de Supervivencia Financiera',
  description: 'Calcula exactamente cuánto te deben y cómo proteger tu dinero'
}, {
  icon: BriefcaseIcon,
  title: 'Hackeo de Recreación Profesional',
  description: 'Sistema probado para conseguir entrevistas rápido'
}];
export function UniqueMechanism() {
  return <section className="bg-navy text-white py-16 px-6" data-id="element-171">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="max-w-6xl mx-auto" data-id="element-172">
        <div className="text-center mb-12" data-id="element-173">
          <h2 className="font-serif text-3xl md:text-5xl mb-6" data-id="element-174">
            El <span className="text-gold" data-id="element-175">Protocolo de Salida Limpia</span>
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto" data-id="element-176">
            Este no es un libro teórico. Es un sistema de defensa táctica
            dividido en tres capas. Pasamos del "modo víctima" al "modo
            estratega" usando los mismos vacíos legales que las empresas usan a
            su favor.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-177">
          {pillars.map((pillar, index) => {
          const Icon = pillar.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.15
          }} className="bg-white/10 backdrop-blur-sm p-8 rounded-lg text-center" data-id="element-178">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-gold rounded-full mb-4" data-id="element-179">
                  <Icon className="w-8 h-8 text-navy" data-id="element-180" />
                </div>
                <h3 className="font-serif text-2xl mb-3 text-gold" data-id="element-181">
                  {pillar.title}
                </h3>
                <p className="text-gray-300" data-id="element-182">{pillar.description}</p>
              </motion.div>;
        })}
        </div>
      </motion.div>
    </section>;
}